export default __webpack_public_path__ + "static/media/newimg1.e25a68fd.png";